import React from 'react';
import { Modal } from 'antd';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';

/**
 * Modal component to display income validation errors
 * Shows specific errors for individual and family income APIs
 */
const IncomeValidationErrorModal = ({ 
  isVisible, 
  onClose, 
  individualError, 
  familyError,
  hasSystemError 
}) => {
  // Check if we have any errors to display
  const hasErrors = individualError || familyError || hasSystemError;

  // Don't render if no errors
  if (!hasErrors) return null;

  const renderErrorContent = () => {
    // If system error (500, network issues, etc.)
    if (hasSystemError) {
      return (
        <div className="error-content">
          <div className="system-error-message">
            Οι υπηρεσίες που προσπαθείτε να καλέσετε είναι προσωρινά μη διαθέσιμες.
            <br />
            Παρακαλώ δοκιμάστε σε λίγο.
          </div>
        </div>
      );
    }

    // Business logic errors from the APIs
    return (
      <div className="error-content">
        {individualError && (
          <div className="error-item">
            <strong>Ατομικό εισόδημα:</strong> {individualError}
          </div>
        )}
        
        {familyError && (
          <div className="error-item">
            <strong>Οικογενειακό εισόδημα:</strong> {familyError}
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={[
        <button key="ok" className="ant-btn ant-btn-primary" onClick={onClose}>
          Εντάξει
        </button>
      ]}
      width={500}
      centered
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <WarningBlue style={{ width: '24px', height: '24px' }} />
          <span>Σφάλμα Επικύρωσης Εισοδήματος</span>
        </div>
      }
    >
      <div className="income-validation-error-modal">
        {renderErrorContent()}
      </div>
      
      <style jsx>{`
        .income-validation-error-modal .error-content {
          padding: 16px 0;
        }
        
        .income-validation-error-modal .error-item {
          margin-bottom: 12px;
          padding: 16px;
          background: linear-gradient(135deg, #f0f7ff 0%, #e6f4ff 100%);
          border: 1px solid #91caff;
          border-left: 4px solid #1677ff;
          border-radius: 8px;
          line-height: 1.6;
          box-shadow: 0 2px 8px rgba(22, 119, 255, 0.08);
        }
        
        .income-validation-error-modal .error-item:last-child {
          margin-bottom: 0;
        }
        
        .income-validation-error-modal .error-item strong {
          color: #0958d9;
          display: block;
          margin-bottom: 6px;
          font-weight: 600;
          font-size: 14px;
        }
        
        .income-validation-error-modal .system-error-message {
          padding: 20px;
          background: linear-gradient(135deg, #fff7e6 0%, #fef3e6 100%);
          border: 1px solid #ffd591;
          border-left: 4px solid #fa8c16;
          border-radius: 8px;
          text-align: center;
          line-height: 1.7;
          color: #d46b08;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(250, 140, 22, 0.08);
        }
        
        .income-validation-error-modal .ant-modal-header {
          background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
          border-bottom: none;
          border-radius: 8px 8px 0 0;
        }
        
        .income-validation-error-modal .ant-modal-title {
          color: white !important;
          font-weight: 600;
        }
        
        .income-validation-error-modal .ant-modal-close {
          color: white !important;
        }
        
        .income-validation-error-modal .ant-modal-close:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
        }
        
        .income-validation-error-modal .ant-modal-content {
          border-radius: 8px;
          overflow: hidden;
        }
        
        .income-validation-error-modal .ant-modal-footer {
          border-top: 1px solid #f0f0f0;
          padding: 16px 24px;
        }
        
        .income-validation-error-modal .ant-btn-primary {
          background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
          border: none;
          border-radius: 6px;
          font-weight: 500;
          height: 36px;
          padding: 0 20px;
          box-shadow: 0 2px 8px rgba(22, 119, 255, 0.2);
        }
        
        .income-validation-error-modal .ant-btn-primary:hover {
          background: linear-gradient(135deg, #0958d9 0%, #003eb3 100%) !important;
          box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3) !important;
        }
      `}</style>
    </Modal>
  );
};

export default IncomeValidationErrorModal;